import { Trans } from '@lingui/react/macro';

import { FileViewerUpload } from '@/components/FileUpload/FileViewerUpload';
import config from '@/config';
import Stack from '@/design_system/Stack';
import { createBEMClasses } from '@/utils/classname';

import { useInvoiceContext } from '../Invoice';

import './InvoiceMedia.css';

const { block } = createBEMClasses('invoice-media');

export const InvoiceMedia = () => {
  const { invoice, showErrors, errors, isDisabled } = useInvoiceContext();

  return (
    <Stack className={block()} gap="4px" style={{ flex: '1 1 400px', maxWidth: '100%' }}>
      <h2 className="label-100-medium">
        <Trans id="invoice.media.title">Invoice</Trans>
      </h2>
      <FileViewerUpload
        uploadData={{ type: 'invoice', invoiceId: invoice.id }}
        media={invoice.media.filter((medium) => medium.type === 'invoice')}
        isInvalid={showErrors && errors.media}
        isDisabled={isDisabled}
        deleteWithApi
        downloadHref={`${config.apiUrl}/invoices/${invoice.id}/media`}
      />
    </Stack>
  );
};
